import Vue from "vue";
import axios from "axios";
import configuration from "@/utils/configuration";

const getDefaultState = () => {
  return {
    loading: {},
    error: {},
    verifyUser: {
      username: null,
      phoneNumber: null,
    },
    newPassBody: {
      otp: null,
      newPassword: null,
      confirmPassword: null,
    },
  };
};
const state = getDefaultState();

export default {

  namespaced: true,
  state,
  getters: {
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
    getPasswordBody: (state) => state.newPassBody,
    getVerifyPassword: (state) => state.verifyUser,
  },
  mutations: {
    RESET_RESET_PASSWORD_INFO(state) {
      Object.assign(state, getDefaultState());
    },
    SET_LOADING(state, { action, status }) {
      Vue.set(state.loading, action, status);
    },
    SET_ERROR(state, { action, message }) {
      Vue.set(state.error, action, message);
    },
    SET_OTP(state, otp) {
      state.newPassBody.otp = otp;
    },
    SET_PASSWORD(state, { password, confirmPassword }) {
      (state.newPassBody.newPassword = password),
        (state.newPassBody.confirmPassword = confirmPassword);
    },
    SET_VERIFY_PASSWORD(state, { username, phoneNumber }) {
      (state.verifyUser.username = username),
        (state.verifyUser.phoneNumber = phoneNumber);
    },
  },
  actions: {
    // ------------ Change Password  -----------  //

    // Reset Password by Phone number

    async resetPasswordBySMS({ commit }, { username, phoneNumber }) {
      const action = "resetPasswordBySMS";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.authUrl}/reset-password/send-otp`,
          data: { username, tel_no: phoneNumber },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {action,message:error.response?.data?.message ||error.message ||`${action} Failed`,});
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async checkCreditential({ commit },) {
      const action = "checkCreditential";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.authUrl}/check-credentials`,
          withCredentials:true
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {action,message:error.response?.data?.message ||error.message ||`${action} Failed`,});
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async refreshToken({ commit }) {
      const action = "refreshToken";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.authUrl}/refresh`,
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {action, message: error.response?.data?.message || error.message || `${action} Failed`});
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async loginSharedToken({ commit },token) {
      const action = "loginSharedToken";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.authUrl}/login/shared-token`,
          data:{shared_token : token},
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {action, message: error.response?.data?.message || error.message || `${action} Failed`});
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async verifyToken({ commit }) {
      const action = "verifyToken";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.authUrl}/verify-token`,
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {action, message: error.response?.data?.message || error.message || `${action} Failed`});
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async resendOTPSMS({ commit,state }) {
      const action = "resendOTPSMS";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.authUrl}/reset-password/send-otp`,
          data: { 
            username: state.verifyUser.username, 
            tel_no: state.verifyUser.phoneNumber },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {action,message:error.response?.data?.message ||error.message ||`${action} Failed`,});
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    // Reset password by Email
    async resetPasswordByEmail({ commit }, { username, email }) {
      const action = "resetPasswordByEmail";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.authUrl}/reset-password/email`,
          data: { username, email },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    // Reset New Password
    async resetNewPassword({ commit, state }) {
      const action = "resetNewPassword";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.authUrl}/reset-password/send-request`,
          data: {
            otp: state.newPassBody.otp,
            new_password: state.newPassBody.newPassword,
            confirm_new_password: state.newPassBody.confirmPassword
          },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {action, message: error.response?.data?.message || error.message || `${action} Failed`});
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    

    // SET DATA FORM USER
    setUserOTP({ commit }, otp) {
      commit("SET_OTP", otp);
    },
    setUserNewPassword({ commit }, { password, confirmPassword }) {
      commit("SET_PASSWORD", { password, confirmPassword });
    },
    setVerifyUser({ commit }, { username, phoneNumber }) {
      commit("SET_VERIFY_PASSWORD", { username, phoneNumber });
    },
    resetPasswordInfo({ commit}) {
      commit('RESET_RESET_PASSWORD_INFO');
    },
  },
};

